import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getCountryList = createAsyncThunk(
  "country/list",
  async ({ pageCount, limit, search }) => {
    const response = await Client(
      API_METHOD.GET,
      url.list_country +
        `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${
          !search ? "" : search
        }`
    );

    return response.data;
  }
);

export const addCountry = createAsyncThunk(
  "country/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.add_country, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editCountry = createAsyncThunk(
  "country/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.edit_country + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getCountryCount = async () =>{
  const response = await Client(API_METHOD.GET, url.list_country);
  return response.data?.data?.item?.total_count;
}

export const getCountry = createAsyncThunk("country/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.list_country + `/${id}`);
  return response.data;
});

export const deleteCountry = createAsyncThunk("country/delete", async (id) => {
  const response = await Client(
    API_METHOD.DELETE,
    url.delete_country + `/${id}`
  );
  return response.data;
});
